module.exports = __webpack_public_path__ + "img/wechat_normal.d7855f4f.svg";